import { Navigate, Route, Routes } from 'react-router-dom';
import { MarketplaceChannelBreakdown } from 'pages/insights-pro/marketplace-tab/reports/marketplace-channel-breakdown/MarketplaceChannelBreakdown';
import { MarketplaceDashboard } from 'pages/insights-pro/marketplace-tab/MarketplaceDashboard';
import { MarketplacesOverTimeReport } from 'pages/insights-pro/marketplace-tab/reports/marketplaces-over-time/MarketplacesOverTimeReport';
import { MarketplaceNetSalesRates } from 'pages/insights-pro/marketplace-tab/reports/net-sales-rates/MarketplaceNetSalesRates';

export function MarketplaceRoutes() {
  return (
    <Routes>
      <Route index element={<MarketplaceDashboard />} />
      <Route path="reports/channel-breakdown" element={<MarketplaceChannelBreakdown />} />
      <Route path="reports/over-time" element={<MarketplacesOverTimeReport />} />
      <Route path="reports/net-sales-rates" element={<MarketplaceNetSalesRates />} />
      <Route path="*" element={<Navigate to="" />} />
    </Routes>
  );
}
